import "./contact.css";
import Phone from "../../img/phone.png";
import Email from "../../img/email.png";
import Address from "../../img/address.png";
import { useContext, useRef, useState } from "react";
import emailjs from "emailjs-com";
import { ThemeContext } from "../../context";

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false);
  const [pending, setPending] = useState(false);
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const handleSubmit = (e) => {
    setPending(true);
    e.preventDefault();
    emailjs
      .sendForm(
        "service_dq5ie0p",
        "template_oc7za4h",
        formRef.current,
        "user_1ZNFGIf9QOKHm7wF8xC2C"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
          setPending(false);
          window.location.reload();
        },
        (error) => {
          console.log(error.text);
          setPending(false);
        }
      );
  };

  return (
    <div className="c">
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">Let's discuss your project</h1>
          <div className="c-info">
            <div className="c-info-item">
              <img src={Phone} alt="" className="c-icon" />
              +211 928 561 654
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Email} alt="" />
              yasonlovictoria@gmail.com
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Address} alt="" />
              Giada Street, Juba South Sudan
            </div>
          </div>
        </div>
        <div className="c-right">
          <p className="c-desc">
            <b>My inbox is open</b> Say "Hi". Always available for freelancing
            if the right project comes along. me.
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            {done && <h2 className="success">Email send successfully!</h2>}

            <input
              style={{ backgroundColor: darkMode && "#333" }}
              type="text"
              placeholder="Name"
              name="user_name"
              required
            />
            <input
              style={{ backgroundColor: darkMode && "#333" }}
              type="text"
              placeholder="Subject"
              name="user_subject"
              required
            />
            <input
              style={{ backgroundColor: darkMode && "#333" }}
              type="text"
              placeholder="Email"
              name="user_email"
              required
            />
            <textarea
              style={{ backgroundColor: darkMode && "#333" }}
              rows="5"
              placeholder="Message"
              name="message"
              required
            />
            <button>{pending ? "Sending..." : "Submit"}</button>
          </form>
          <a
            href="https://www.buymeacoffee.com/logburo"
            target="_blank"
            style={{ margin: "20px 0 0 0" }}
          >
            <img
              src="https://cdn.buymeacoffee.com/buttons/default-orange.png"
              alt="Buy Me A Coffee"
              style={{ height: "41px", width: "174px" }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
